export default "__VITE_ASSET__UDtyCKaE__"